export type Lang = 'de' | 'en';

export interface Strings {
  langName: string;
  switchTo: string;
  nav: { privacy: string; imprint: string; allTools: string };
  hero: { title: string; subtitle: string; localBadge: string };
  ui: {
    dropTitle: string;
    dropHint: string;
    format: string;
    quality: string;
    resize: string;
    maxWidth: string;
    convert: string;
    download: string;
    remove: string;
    error: string;
  };
  seo: {
    aboutTitle: string;
    aboutBody: string;
    faqTitle: string;
    faq: { q: string; a: string }[];
  };
  footer: { rights: string; noStorage: string };
}

const de: Strings = {
  langName: 'Deutsch',
  switchTo: 'English',
  nav: { privacy: 'Datenschutz', imprint: 'Impressum', allTools: 'Alle Tools' },
  hero: {
    title: 'Bildformat-Converter',
    subtitle:
      'Wandle Bilder zwischen PNG, JPEG und WebP um, optional verkleinern, direkt im Browser. Dein Bild wird nicht hochgeladen.',
    localBadge: '100 % lokal · kostenlos',
  },
  ui: {
    dropTitle: 'Bild hierher ziehen',
    dropHint: 'oder klicken — PNG, JPG, WebP, GIF. Bleibt lokal.',
    format: 'Zielformat',
    quality: 'Qualität',
    resize: 'Verkleinern',
    maxWidth: 'Maximale Breite',
    convert: 'Erneut umwandeln',
    download: 'Herunterladen',
    remove: 'Bild entfernen',
    error: 'Bild konnte nicht verarbeitet werden. Bitte ein anderes versuchen.',
  },
  seo: {
    aboutTitle: 'Bilder sicher und lokal umwandeln',
    aboutBody:
      'Dieser Converter wandelt Bilder zwischen PNG, JPEG und WebP um und kann sie verkleinern — ausschließlich lokal in deinem Browser über ein Canvas. Dein Bild wird nicht hochgeladen oder gespeichert.',
    faqTitle: 'Häufige Fragen',
    faq: [
      {
        q: 'Wird mein Bild hochgeladen?',
        a: 'Nein. Die Umwandlung läuft lokal im Browser; es findet keine Übertragung statt.',
      },
      {
        q: 'Welches Format soll ich wählen?',
        a: 'WebP bietet meist die beste Kompression bei guter Qualität. PNG für verlustfreie Grafiken mit Transparenz, JPEG für Fotos.',
      },
      {
        q: 'Bleibt die Transparenz erhalten?',
        a: 'Bei PNG und WebP ja. JPEG kann keine Transparenz, dort wird der Hintergrund weiß gefüllt.',
      },
    ],
  },
  footer: {
    rights: 'Kostenlose Tools von ecosquirrel.',
    noStorage: 'Keine serverseitige Speicherung. Alles läuft lokal im Browser.',
  },
};

const en: Strings = {
  langName: 'English',
  switchTo: 'Deutsch',
  nav: { privacy: 'Privacy', imprint: 'Imprint', allTools: 'All tools' },
  hero: {
    title: 'Image Format Converter',
    subtitle:
      'Convert images between PNG, JPEG and WebP, optionally resize, right in your browser. Your image is never uploaded.',
    localBadge: '100% local · free',
  },
  ui: {
    dropTitle: 'Drop an image here',
    dropHint: 'or click — PNG, JPG, WebP, GIF. Stays local.',
    format: 'Target format',
    quality: 'Quality',
    resize: 'Resize',
    maxWidth: 'Max width',
    convert: 'Convert again',
    download: 'Download',
    remove: 'Remove image',
    error: 'Could not process the image. Please try another one.',
  },
  seo: {
    aboutTitle: 'Convert images securely and locally',
    aboutBody:
      'This converter changes images between PNG, JPEG and WebP and can resize them — exclusively in your browser via a canvas. Your image is not uploaded or stored.',
    faqTitle: 'Frequently asked questions',
    faq: [
      {
        q: 'Is my image uploaded?',
        a: 'No. Conversion runs locally in the browser; nothing is transmitted.',
      },
      {
        q: 'Which format should I choose?',
        a: 'WebP usually offers the best compression at good quality. PNG for lossless graphics with transparency, JPEG for photos.',
      },
      {
        q: 'Is transparency preserved?',
        a: 'For PNG and WebP yes. JPEG has no transparency, so the background is filled white.',
      },
    ],
  },
  footer: {
    rights: 'Free tools by ecosquirrel.',
    noStorage: 'No server-side storage. Everything runs locally in your browser.',
  },
};

export const STRINGS: Record<Lang, Strings> = { de, en };
